// extracted by mini-css-extract-plugin
export var errorIcon = "_m5-1";
export var nameLogo = "_m5-0";